// Copyright (c) 2021 Deere & Company

import React, {PropTypes} from 'react';
import LaborRate from '@deere/cps-it.warranty-model-factory/lib/labor-rate';
import {buildDealer} from '../../../shared/services/build-dealer';

const DealershipModalBody = props =>
    <div className='dealership-modal-body'>
        <ul>
            {props.laborRateAll.map((laborRate, index) => (
                <li key={index}>
                    {buildDealer(laborRate.responsibleAccount, '01')}
                </li>
            ))}
        </ul>
    </div>;

DealershipModalBody.displayName = 'DealershipModalBody';
DealershipModalBody.propTypes = {
    laborRateAll: PropTypes.arrayOf(PropTypes.instanceOf(LaborRate)).isRequired
};

export default DealershipModalBody;



// WEBPACK FOOTER //
// ./src/shared/components/dealership-detail-modal/dealership-modal-body.js